import { useCallback } from 'react';

import styled from 'styled-components';
import { useRfqBuilderModalMethods } from '@paradigm/features/src/unified-rfqs/ui/rfq-builder/modal-context';
import {
  useRfqBuilderView,
  useSend,
} from '@paradigm/features/src/unified-rfqs/ui';
import { useSubmitted } from '@paradigm/features/src/forms/submitted-context';

import { toast } from '#/components/UnifiedRfqs/toast';

import Button from '@paradigm/design-system/src/components/Button';
import { useTrackAction } from '@paradigm/features/src/analytics';
import { firefly } from '@paradigm/design-system/src/colors';
import { useBottomTabsMethods } from '@paradigm/features/src/unified-rfqs/ui/bottom-tabs';

const StyledButton = styled(Button)`
  margin-right: 1rem;
  background-color: ${firefly};
`;

export default function SaveDraftButton() {
  const rfqBuilderModal = useRfqBuilderModalMethods();
  const { isValid, hedge } = useRfqBuilderView();
  const { isLoading, send } = useSend(false);
  const { setTab } = useBottomTabsMethods();
  const { setSubmit } = useSubmitted();
  const trackAction = useTrackAction();

  const handleClick = useCallback(() => {
    trackAction('save draft');
    if (hedge.submitMsg !== undefined) {
      toast(hedge.submitMsg);
      return;
    }
    setSubmit(true);

    if (!isValid) return;
    send(
      (resp) => {
        if (resp.ok) {
          rfqBuilderModal.close();
          setTab('rfqs-drafts');
        } else {
          toast(resp.message);
        }
      },
      { state: 'DRAFT' },
    );
  }, [
    trackAction,
    hedge.submitMsg,
    setSubmit,
    isValid,
    send,
    rfqBuilderModal,
    setTab,
  ]);

  return (
    <StyledButton
      ariaLabel="Save Draft"
      size="large"
      type="submit"
      isValid={isValid}
      onClick={handleClick}
      isLoading={isLoading}
    >
      Save Draft
    </StyledButton>
  );
}
